import { z } from 'zod';
export function envelope(data, meta) {
    return meta ? { data, meta } : { data };
}
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
    sort: z.string().optional(),
    q: z.string().trim().min(1).max(200).optional(),
});
export const uuidSchema = z.string().uuid();
//# sourceMappingURL=envelope.js.map